import type { AuthErrorKeyMap } from '../../../types/auth';

export const signInAuthErrorConfig: AuthErrorKeyMap = {
    key: 'signIn',
    value: {
        400: {
            invalid_credentials: 'errors.frontend.signIn.invalidCredentials',
        },
        default: 'errors.frontend.signInFailed',
    },
};
